import styled from "styled-components";

export const StyledFileSpeechBalloon = styled.div<{
  reverse?: boolean;
}>`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  justify-content: space-between;
  align-items: ${({ reverse }) => (reverse ? "flex-end" : "normal")};
`;
